import { useEffect } from 'react';

const AppRedirect = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    // Define your store URLs here
    const appleStoreUrl = "https://apps.apple.com/us/app/eje/id6448539365";
    const googlePlayUrl = "https://play.google.com/store/apps/details?id=ae.eje.app";
    const webFallbackUrl = "https://eje.ae"; // For desktop users

    // 1. Check for iOS (iPhone, iPad, iPod)
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.replace(appleStoreUrl);
    } 
    // 2. Check for Android
    else if (/android/i.test(userAgent)) {
      window.location.replace(googlePlayUrl);
    } 
    // 3. Fallback for Desktop/Others
    else {
      window.location.replace(webFallbackUrl);
    }
  }, []);

  // Show a simple message while the logic runs
  return (
    <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh', fontFamily: 'sans-serif' }}>
      <h3>Redirecting you to the store</h3>
    </div>
  );
};

export default AppRedirect;